export default __webpack_public_path__ + "static/media/slider1.5ba3c0a8.jpg";